import { useEffect, useState } from 'react';
import {
  Text,
  VStack,
  Menu,
  MenuButton,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  Button,
} from '@chakra-ui/react';
import { FiChevronDown } from 'react-icons/fi';
import { useRecoilValue } from 'recoil';
import { selectedLockYearState } from '@transport-insights/uikit';

export default function ReportToggles({
  options,
  text,
  isMulti,
  onSelectToggle,
}) {
  const lockYear = useRecoilValue(selectedLockYearState);

  const [selectedToggleOption, setSelectedToggleOption] = useState(
    isMulti ? options.map((x) => x.value) : options[0]?.value,
  );

  useEffect(() => {
    if (options?.length > 0) {
      setSelectedToggleOption(
        isMulti ? options.map((x) => x.value) : options[0].value,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleToggleOption = (val) => {
    setSelectedToggleOption(val);
    onSelectToggle(val);
  };

  const renderToggleLabel = (label) => {
    if (label.includes('Calendar Year')) {
      return `${label} (${lockYear.split('/')[0]})`;
    }
    if (label.includes('Financial Year')) {
      return `${label} (${lockYear})`;
    }
    return label;
  };

  const selectedLabel = () => {
    if (isMulti) {
      return `${selectedToggleOption.length} selected`;
    }
    return renderToggleLabel(
      options.find((o) => o.value === selectedToggleOption)?.label ?? '',
    );
  };

  return (
    <VStack spacing={1} align="start">
      <Text fontSize="xs" color="gray.600" textTransform="uppercase" fontWeight="bold">
        {text}
      </Text>
      <Menu closeOnSelect={!isMulti}>
        <MenuButton
          as={Button}
          size="sm"
          variant="outline"
          colorScheme="gray"
          rightIcon={<FiChevronDown />}
        >
          {selectedLabel()}
        </MenuButton>

        <MenuList minW="240px">
          <MenuOptionGroup
            type={isMulti ? 'checkbox' : 'radio'}
            value={selectedToggleOption}
            onChange={handleToggleOption}
          >
            {options.map(({ label, value }) => (
              <MenuItemOption key={value} value={value}>
                {renderToggleLabel(label)}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </VStack>
  );
}
